import React from 'react';
import PropTypes from 'prop-types';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

class FiltersCategory extends React.Component {
    constructor(props) {
        super(props);

        this.updateSelection = this.updateSelection.bind(this);
    }

    updateSelection(event, code) {
        event.preventDefault();
        this.props.changeCategory(code);
    }

    render() {
        const { colander } = this.props;
        const categoryLinkClasses = ['sr-link category-link sr-text is-small'];
        if (colander.isSelected) {
            categoryLinkClasses.push('selected is-bold is-price');
        }
        return (
            <li>
                <button
                    className={categoryLinkClasses.join(' ')}
                    onClick={(event) => this.updateSelection(event, colander.code)}
                >
                    {colander.label}
                </button>
            </li>
        );
    }
}

FiltersCategory.propTypes = {
    colander: PropTypes.instanceOf(MetaDataModel).isRequired,
    changeCategory: PropTypes.func.isRequired,
};

FiltersCategory.displayName = 'FiltersCategory';

export default FiltersCategory;
